/* eslint-disable @typescript-eslint/no-misused-promises */
import React from "react";

import { Form, Input, Select, Row, Col } from "antd";
import { omit } from "lodash-es";

import { IFormsProps } from "../../../types";
import FormFooter from "../FormFooter";

interface IFormInputs {
    title: string;
}

// TODO: ability to specify what field changed, ability to specify what field changed to, display custom fields
export default function ContactUpdatedTriggerForm({
    initialData,
    canDelete = true,
    onCancel,
    onSubmit,
    onDelete,
}: IFormsProps) {
    const [form] = Form.useForm();
    const initialValues = {
        title: initialData?.label ?? "",
    };

    const sumbit = (data: IFormInputs) => {
        onSubmit({
            ...omit(data, ["title"]),
            label: data.title,
        });
    };

    return (
        <div className="form-layout">
            <Form
                layout="vertical"
                form={form}
                initialValues={initialValues}
                onFinish={sumbit}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 24 }}
            >
                <Form.Item
                    label="Trigger Name"
                    name="title"
                    rules={[{ required: true, message: "Trigger Name is required field" }]}
                >
                    <Input placeholder="Trigger Name" />
                </Form.Item>
                <Form.Item>
                    <Row gutter={8}>
                        <Col span={8}>
                            <Form.Item name="field" rules={[{ required: true, message: "Field is required field" }]}>
                                <Select
                                    className="field"
                                    options={[
                                        { value: "field1", label: "Field1" },
                                        { value: "field2", label: "Field2" },
                                    ]}
                                    placeholder="Field"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="operator"
                                rules={[{ required: true, message: "Operator is required field" }]}
                            >
                                <Select
                                    className="field"
                                    options={[
                                        { value: "has_changed", label: "Has Changed" },
                                        { value: "has_changed_to", label: "Has Changed To" },
                                    ]}
                                    placeholder="Operator"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item
                                name="custom_fields"
                                rules={[{ required: true, message: "Status Changed To is required field" }]}
                            >
                                <Select
                                    className="field"
                                    options={[
                                        { value: "custom_field_1", label: "Custom Field 1" },
                                        { value: "custom_field_2", label: "Custom Field 2" },
                                    ]}
                                    placeholder="Select"
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form.Item>
                <FormFooter onCancel={onCancel} canDelete={canDelete} onDelete={onDelete} />
            </Form>
        </div>
    );
}
